import { isArray, isResultSet } from '@spazious/mathjs';

import { ScopeExpression } from './ScopeExpression.js';
import { Scope } from './types.js';

/**
 * Evaluates a scope expression, that caches the result of the evaluation
 * allowing transitive expressions.
 */
export class ScopeEvaluator {
  scope: Scope;
  stack: Set<unknown>;
  cache: Map<any, any>;
  constructor(scope: Scope) {
    this.scope = scope;
    this.stack = new Set();
    this.cache = new Map();
  }

  evaluate(expr: ScopeExpression) {
    const { path, fallback } = expr;

    let value = null;

    if (this.stack.has(path)) {
      return this.cache.get(path) ?? fallback;
    }
    this.stack.add(path);
    try {
      value = expr.evaluate();
      if (isResultSet(value) && isArray(value)) {
        value = value[value.length - 1];
      }
    } catch (e: any) {
      console.warn(
        [
          `Error evaluating the expression for "${path}"`,
          ` - StackTrace: ${Array.from(this.stack).join(' -> ')}`,
          ` - ${(e as Error).name}: ${e.message}`,
        ].join('\n')
      );
      value = fallback;
      throw e;
    }
    this.stack.delete(path);
    this.cache.set(path, value);
    return value;
  }

  reset() {
    this.stack.clear();
    this.cache.clear();
  }
}
